import i18n from '@/locales'
export default {
  created () {
    this.columns = [
      {
        field: 'cpu_core_count',
        title: i18n.t('scope.text_898'),
        width: 100,
      },
      {
        field: 'cpu_core_count',
        title: i18n.t('scope.text_866'),
        width: 100,
      },
      {
        field: 'memory_size_mb',
        title: i18n.t('scope.text_899'),
        width: 100,
      },
      {
        field: 'total_guest_count',
        title: i18n.t('scope.text_679'),
        width: 100,
      },
      {
        field: 'total_guest_count',
        title: i18n.t('scope.text_900'),
        width: 100,
      },
      {
        field: 'total_guest_count',
        title: i18n.t('scope.text_901'),
        width: 100,
      },
      {
        field: 'total_guest_count',
        title: i18n.t('scope.text_902'),
        width: 100,
      },
      {
        field: 'total_guest_count',
        title: i18n.t('scope.text_647'),
        width: 100,
      },
      {
        field: 'total_guest_count',
        title: i18n.t('scope.text_577'),
        width: 100,
      },
    ]
  },
}
